export const SHEET_METAL_PROCESSES = {
  BENDING: 'bending',
  CUTTING: 'cutting',
  GENERAL: 'general',
  MACHINING: 'machining',
  PUNCHING: 'punching',
} as const;

export const SHEET_METAL_COSTING_VARIABLE_KEYS = {
  BEND_COUNT: 'bendCount',
  OPEN_HEM_COUNT: 'openHemCount',
  OFFSET_COUNT: 'offsetCount',
  CURL_COUNT: 'curlCount',
  TEAR_DROP_COUNT: 'tearDropCount',
  EMBOSSMENT_COUNT: 'embossmentCount',
} as const;

export const SHEET_METAL_GENERAL_VARIABLE_KEYS = {
  DIMENSIONS: 'dimensions',
  FLAT_DIMENSIONS: 'flatDimensions',
  SURFACE_AREA: 'surfaceArea',
  WEIGHT: 'weight',
} as const;

export const SHEET_METAL_MACHINING_VARIABLE_KEYS = {
  COUNTER_BORE_COUNT: 'counterBoreCount',
  COUNTER_BORE_SETUPS: 'counterBoreSetups',
  COUNTER_SINK_COUNT: 'counterSinkCount',
  COUNTER_SINK_SETUPS: 'counterSinkSetups',
  DRILLED_HOLE_COUNT: 'drilledHoleCount',
  DRILLED_HOLE_SETUPS: 'drilledHoleSetups',
} as const;

export const SHEET_METAL_PUNCHING_VARIABLE_KEYS = {
  SINGLE_HIT_COUNT: 'singleHitCount',
  SINGLE_HIT_SETUPS: 'singleHitSetups',
  MULTI_HIT_CUT_LENGTH: 'multiHitCutLength',
} as const;

export const SHEET_METAL_CUTTING_VARIABLE_KEYS = {
  CUT_LENGTH: 'cutLength',
  AIR_MOVE_LENGTH: 'airMoveLength',
  PIERCE_COUNT: 'pierceCount',
} as const;
